export class Blackbox {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.0.1';
        this.power = false;
        this.presets = [];
        this.videoOutputs = [];
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\^Version/i,
                callback: (match) => {
                    this.socket.send(`V${this.firmwareVersion}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /STA_VIDEO/i,
                callback: (match) => {
                    this.videoOutputs.forEach((videoOutput, i) => {
                        if (i !== 0) {
                            this.socket.send(`Output ${i
                                .toString()
                                .padStart(2, '0')} Switch To ${videoOutput.padStart(2, '0')}!`);
                        }
                    });
                },
            },
            {
                name: 'setRoute',
                regExp: /OUT(\d+):(\d+)/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    if (output === 0) {
                        // All outputs
                        this.videoOutputs.fill(match[2]);
                    }
                    else {
                        this.videoOutputs[output] = match[2];
                    }
                    this.socket.send(`Output ${match[1]} Switch To ${match[2].padStart(2, '0')}!`);
                },
            },
            {
                name: 'setRouteAll',
                regExp: /(\d+)ALL/i,
                callback: (match) => {
                    this.videoOutputs.forEach((videoOutput, i) => {
                        this.videoOutputs[i] = match[1];
                        this.socket.send(`Output ${i.toString().padStart(2, '0')} Switch To ${match[1].padStart(2, '0')}!`);
                    });
                },
            },
            {
                name: 'powerSet',
                regExp: /Power(ON|OFF)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON' ? true : false;
                    this.socket.send(this.power ? 'Power ON!' : 'Power OFF!');
                },
            },
            {
                name: 'presetQuery',
                regExp: /PresetSta(\d+)/i,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    this.socket.send(`Preset${match[1]} Sta:`);
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            this.socket.send(`Out ${(i + 1).toString().padStart(2, '0')} In ${preset[i].padStart(2, '0')}!`);
                        });
                    }
                },
            },
            {
                name: 'presetRecall',
                regExp: /PresetRecall(\d+)/i,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    this.socket.send(`Preset${match[1]} Recall:`);
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            this.videoOutputs[i] = preset[i];
                            this.socket.send(`Output ${(i + 1).toString().padStart(2, '0')} Switch To ${preset[i].padStart(2, '0')}!`);
                        });
                    }
                },
            },
            {
                name: 'presetSave',
                regExp: /PresetSave(\d+)/i,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            preset[i] = videoOutput;
                        });
                    }
                    this.socket.send(`Preset${match[1]} Save Success!`);
                },
            },
            // The documentation doesn't describe the power get feature. I'm assuming it's part
            // STA status command.
            {
                name: 'Status',
                regExp: /STA/i,
                callback: (match) => {
                    this.getStatusResponse().forEach(resp => this.socket.send(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`CMD Error!`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['.'],
        };
        this.sendTerminator = '\r\n';
    }
    onConfigure(config) {
        var _a;
        const numOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
        this.videoOutputs = Array(numOutputs + 1).fill('1');
        this.presets = Array(6).fill(Array(numOutputs).fill('1'));
    }
    getStatusResponse() {
        const response = [];
        response.push('GUI Or RS232 Query Status:');
        response.push(`Black Box AVS-HDMI2-${this.videoOutputs.length}x${this.videoOutputs.length}-R2`);
        response.push(`${this.firmwareVersion}`);
        response.push(`Power ${this.power ? 'ON' : 'OFF'}!`);
        response.push('Front Panel UnLock!');
        response.push('GUI_IP:192.168.0.172!');
        this.videoOutputs.forEach((videoOutput, i) => {
            if (i !== 0) {
                // 0 represents all outputs
                response.push(`Output ${i.toString().padStart(2, '0')} Switch to ${videoOutput.padStart(2, '0')}!`);
            }
        });
        return response;
    }
}
Blackbox.emulatorType = 'socketEmulator';
Blackbox.key = '-NFoGs8jA1f3moi0PXZM';
